import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { FilterCard } from "../components/react-components/shared-components/SideFilter/FilterCard";
import { Pagination } from "../components/react-components/search-news-components/Pagination";
import { Info } from "../components/react-components/search-news-components/InfoBar";
import { Container, FiltersContainer, ContentContainer } from "../components/react-components/shared-components/Ui/Grid/Grid";
import { Title } from "../components/react-components/shared-components/Title/Title";
import { View } from "../components/react-components/search-news-components/Views/View";
import { NewsSearchProvider } from "./Context/NewsSearchContext";
import { Filters } from "../components/react-components/search-news-components/Filters";
import Theme from "../components/react-components/Styles/Theme";
import { ThemeProvider } from "styled-components";
import { CleanFilters } from "../components/react-components/search-news-components/CleanFilters";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import i18n from "../i18n/i18n";
import { SearchBar } from "../components/react-components/search-news-components/SearchBar";
import { PageLoading } from "../components/react-components/shared-components/Loading/PageLoading";
var SearchNews = function () {
    React.useEffect(function () {
        var _a;
        // @ts-ignore
        var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
        if ((langCode === null || langCode === void 0 ? void 0 : langCode.length) === 2) {
            i18next.changeLanguage(langCode);
        }
    }, []);
    return (_jsx(Suspense, { fallback: _jsx(PageLoading, {}), children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(NewsSearchProvider, { children: _jsx(ThemeProvider, { theme: Theme, children: _jsx("div", { className: "pg-news", children: _jsxs(Container, { children: [_jsxs(FiltersContainer, { children: [_jsx(SearchBar, {}), _jsxs(FilterCard, { children: [_jsx(CleanFilters, {}), _jsx(Filters, {})] })] }), _jsxs(ContentContainer, { children: [_jsx(Title, { title: "Derni\u00E8res nouvelles" }), _jsx(Info, {}), _jsx(Pagination, {}), _jsx(View, {}), _jsx(Pagination, {})] })] }) }) }) }) }) }));
};
var domNode = document.getElementById("search-news");
if (domNode) {
    var root = createRoot(domNode);
    root.render(_jsx(SearchNews, {}));
}
